import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <div className="navbar-footer">
        <Link to="/story" className="navbar-links-footer">
          OUR STORY
        </Link>
        <Link to="/menu" className="navbar-links-footer">
          MENUS
        </Link>
        <Link to="locations" className="navbar-links-footer">
          LOCATIONS
        </Link>
        <Link to="/gifcards" className="navbar-links-footer">
          GIFT CARDS
        </Link>
        <Link to="/takeaway" className="navbar-links-footer">
          ONLINE ORDER
        </Link>
        <Link to="/catering" className="navbar-links-footer">
          CATERING
        </Link>
        <Link to="/contact" className="navbar-links-footer">
          CONTACT
        </Link>
      </div>
      <img
        src="https://i.imgur.com/1EBXSNB.png"
        alt="Logo"
        className="logo-footer"
      />
    </div>
  );
}

export default Footer;
